import React from 'react'

import { Dropdown } from 'antd'
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons/faEllipsisV'
import IconButton from 'components/buttons/icon'

import styles from './styles.less'

const items = [
  {
    key: 'update',
    label: 'Edit'
  },
  {
    key: 'duplicate',
    label: 'Duplicate'
  },
  {
    key: 'delete',
    label: 'Delete'
  }
]

const Actions = ({ widget, onDelete, onEdit, onDuplicate }) => {
  if (!widget) return null

  const onClick = ({ key }) => {
    switch (key) {
      case 'update':
        onEdit(widget)
        break
      case 'duplicate':
        onDuplicate(widget)
        break
      case 'delete':
        onDelete(widget)
        break
      default:
        break
    }
  }

  return (
    <Dropdown menu={{ items, onClick }} trigger={['click']}>
      <IconButton icon={faEllipsisV} className={styles.extra} />
    </Dropdown>
  )
}

export default Actions
